import React from 'react';
import { useAuth } from '../hooks/useAuth';

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="dashboard-container">
      <h1>Dashboard</h1>
      
      {user && (
        <div className="welcome-section">
          <h2>Welcome, {user.firstName || user.email}!</h2>
          <p>This is your personal dashboard where you can manage your account and access features.</p>
        </div>
      )}
      
      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h3>Your Profile</h3>
          <p>View and edit your profile information</p>
          <button>Manage Profile</button>
        </div>
        
        <div className="dashboard-card">
          <h3>Feature 1</h3>
          <p>Access feature 1 functionality</p>
          <button>Go to Feature 1</button>
        </div>
        
        <div className="dashboard-card">
          <h3>Feature 2</h3>
          <p>Access feature 2 functionality</p>
          <button>Go to Feature 2</button>
        </div>
        
        <div className="dashboard-card">
          <h3>Feature 3</h3>
          <p>Access feature 3 functionality</p>
          <button>Go to Feature 3</button>
        </div>
      </div>
      
      <div className="activity-section">
        <h3>Recent Activity</h3>
        <p>You don't have any recent activity.</p>
        {/* This would normally display recent activity from the backend */}
      </div>
    </div>
  );
};

export default Dashboard;